// lazy-load.service.ts
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LazyLoadService {
  private observer = new IntersectionObserver(this.onIntersect.bind(this), {
    rootMargin: '200px'
  });
  private callbacks = new WeakMap<Element, () => void>();

  observe(el: Element, cb: () => void) {
    this.callbacks.set(el, cb);
    this.observer.observe(el);
  }

  private onIntersect(entries: IntersectionObserverEntry[]) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const cb = this.callbacks.get(entry.target);
        if (cb) {
          cb();
          this.observer.unobserve(entry.target);
          this.callbacks.delete(entry.target);
        }
      }
    });
  }
}